var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var StyledLabel = styled.label(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  cursor: pointer;\n  position: relative;\n  padding-left: 30px;\n  font-size: 0.7rem;\n",
    ]))
);
export var StyledRadioButton = styled.span(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      '\n  height: 20px;\n  width: 20px;\n  border: 1px solid black;\n  border-radius: 50%;\n  display: inline-block;\n  position: absolute;\n  left: 0;\n  &::after {\n    content: "";\n    display: block;\n    height: 12px;\n    width: 12px;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #000000;\n    opacity: 0;\n    transition: opacity 0.2s;\n  }\n',
    ]))
);
export var StyledInput = styled.input(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  display: none;\n  &:checked ~ ",
      " ",
      "::after {\n    opacity: 1;\n  }\n",
    ])),
  StyledLabel,
  StyledRadioButton
);
